var MyClass = function MyClass() {};

MyClass.displayName = "MyClass";